// https://stackoverflow.com/a/74462617
export const IS_NEXT_JS = typeof window !== 'undefined' && 'next' in window
